<template>
  <b-row
    align-v="center"
    @mouseover="setContextOnHover(contextHelpRoot+'Time')"
    @mouseleave="setContextOnHover(contextHelpRoot+'Time')"
  >
    <b-col class="m-0">
      <p class="label">
        {{ axis }}-axis (Time)
      </p>
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="InputTime" />
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="OutputTime" />
    </b-col>
    <b-col class="m-0">
      <CheckBoxConfiguration
        :controller="Log_axis"
        :switchprop="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import {comboBoxConfCtrller, checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import SimpleDropdownConfiguration from '../elements/SimpleDropdownConfiguration'
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import { TypeAxis, ConfigName } from '@/common/plotDefinitions.js'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'

export default {
  name: 'TimeConfiguration',
  components: { 
    SimpleDropdownConfiguration,
    CheckBoxConfiguration
  },
  props: {
    axis:{
      type:String,
      required:true
    },
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data () {
    return {
      elementsConfig:[],
      InputTime: new comboBoxConfCtrller(TypeAxis.time.inputConfig,
        [
          {text:'s',value:'s'},
          {text:'min',value:'min'},
          {text:'hours',value:'hours'},
          {text:'day',value:'day'}
        ],'Input Time',0,`${contextHelpRoot}InputTime`,true),
      OutputTime: new comboBoxConfCtrller(TypeAxis.time.outputConfig,
        [
          {text:'s',value:'s'},
          {text:'min',value:'min'},
          {text:'hours',value:'hours'},
          {text:'day',value:'day'}
        ],'Output Time',0,`${contextHelpRoot}OutputTime`,true),
      Log_axis: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.LOG{0}_BOOL`,'',false,contextHelpRoot+'Log_axis'),
      contextHelpRoot
    }
  },
  mounted(){
    this.elementsConfig=[
      this.InputTime,
      this.OutputTime,
      this.Log_axis
    ]
    this.Log_axis.formatKeyValue(this.axis)
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:mapActions(['setContextOnHover','setConfigReportModifiedReportViewer']),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>
